import style from "../calculator.module.css";
function EditableBonus(props) {
  const {
    statusMode,
    bonusValue,
    setBonusValue,
    bonusProportionValue,
    setBonusProportionValue,
    managerCalcRiskFreeBettingFormula
  } = props;
  function changeBonusValue(e) {
    const { value } = e.target;
    const valueConverted = Number(value);
    if (isNaN(valueConverted) === false) {
      setBonusValue(valueConverted);
      managerCalcRiskFreeBettingFormula({ paramBonusValue: valueConverted });
    }
  }
  function changeConversionBonusValue(e) {
    const { value } = e.target;
    const valueConverted = Number(value);
    if (isNaN(valueConverted) === false) {
      setBonusProportionValue(valueConverted);
      managerCalcRiskFreeBettingFormula({ paramConversionBonusValue: valueConverted });
    }
  }
  return (
        <>
            <div>
                Valor do Bônus:{" "}
                <input
                    className={`align-self-center form-control text-end ${statusMode
                        ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}`
                        : ""
                        }  `}
                    type="number"
                    defaultValue={bonusValue}
                    onChange={changeBonusValue}
                    style={{ width: "180px" }}
                    min={0}
                />
            </div>

            <div>
                Conversão de Bônus:{" "}
                <input
                    className={`align-self-center form-control text-end ${statusMode
                        ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}`
                        : ""
                        }  `}
                    type="number"
                    defaultValue={bonusProportionValue}
                    onChange={changeConversionBonusValue}
                    style={{ width: "180px" }}
                    min={0}
                />
            </div>
        </>
    );
}
export {
  EditableBonus
};